import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService, TokenService } from '../../api';
import { EnvironmentService } from '../../services/environment.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { LoginBase } from '../models';

/**
 * This service handles the authentication methods.
 *
 * @export
 * @class UserAuthenticationService
 */
@Injectable({
  providedIn: 'root',
})
export class LaravelPassportService<T> extends AuthenticationService<T> {
  constructor(
    readonly environmentService: EnvironmentService,
    readonly tokenService: TokenService,
    readonly apiService: ApiService,
    readonly router: Router,
    readonly http: HttpClient
  ) {
    super(environmentService, tokenService, apiService, router, http);
  }

  /**
   * This function registrate one user to the API.
   *
   * @param {{
   *     firstName: string;
   *     lastName: string;
   *     email: string;
   *     password: string;
   *     passwordConfirmation: string;
   *   }} user
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   */
  public registrateUser(user: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    passwordConfirmation: string;
  }): Observable<boolean> {
    const params = new HttpParams();
    params.append('first_name', user.firstName);
    params.append('last_name', user.lastName);
    params.append('email', user.email);
    params.append('password', user.password);
    params.append('password_confirmation', user.passwordConfirmation);

    return this.http
      .post(`${this.environment.apiUrl}/register`, params.toString(), {
        headers: this.header,
      })
      .pipe(map((res) => this.handleSuccess(res as any)));
  }

  /**
   * This function gains the Tokens from the Laravel Passport api.
   *
   * @param {LoginBase} loginData
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   * @deprecated
   */
  public obtainAccessToken(loginData: LoginBase): Observable<boolean> {
    const params = new HttpParams();
    params.append('username', loginData.email);
    params.append('password', loginData.password);
    params.append('grant_type', 'password');
    params.append('client_id', '-');
    params.append('client_secret', '-');

    return this.http
      .post(`${this.environment.apiUrl}/oauth/token`, params.toString(), { headers: this.header })
      .pipe(map((res) => this.handleSuccess(res as any)));
  }

  /**
   * This function resets the Access token.
   *
   * @private
   * @param {string} token
   * @returns {Observable<boolean>}
   * @memberof UserAuthenticationService
   */
  protected refreshAccessToken(token: string): Observable<boolean> {
    const params = new HttpParams();
    params.append('refresh_token', token);
    params.append('grant_type', 'refresh_token');
    params.append('client_id', '-');
    params.append('client_secret', '-');

    return this.http
      .post(`${this.environment.apiUrl}/oauth/token`, params.toString(), { headers: this.header })
      .pipe(map((res) => this.handleSuccess(res as any)));
  }
}
